import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Scaling Laws for Human Motion Generation | Cartwheel',
  'Scaling laws for human motion generation.',
);

export default BlogArticlePage;
